export const teams: TableModule = {
    name: 'teams',
    route: 'spa.organisations.teams',
    defaultOrder: {
        column: 'name',
        direction: 'asc'
    },
    routeParams: [{
        param: 'organisation',
        prop: 'organisation_id'
    }],
    columns: [
        {
            name: 'name',
            sortable: true,
            sortBy: 'name',
            mobile: true
        },
        {
            name: 'jersey_color',
            breakpoint: 'xl',
        },
        {
            name: 'persons',
            breakpoint: 'md',
        },
        {
            name: 'contestRegistrations',
            breakpoint: 'xl',
        },
        {
            name: 'active',
            sortable: true,
            width: "w-[100px]"
        }
    ],
    filters: [],
    quickFilters: [
        {
            name: 'qfActiveOnly',
            column: 'active',
            operator: '=',
            value: true,
            default: true,
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ['create', 'teams']
        }, {
            name: 'teams.registerToContest',
            ability: ['registerToContest', 'teams']
        }
    ]
}

